import { Combobox, useCombobox } from '@mantine/core';
import { ScheduleHeader } from '@mantine/schedule';
import { useTranslation } from 'react-i18next';
import { EVENT_TYPE_OPTIONS } from '../../../../data';
import type { EventType } from '../../../../types';
import { ScheduleFilterComboboxOption } from './components';

const TRANS_PATH = 'TOURING_SCHEDULE';

type ScheduleFilterComboboxPropsType = {
  filter: EventType[];
  setFilter: (filter: EventType[]) => void;
};

export const ScheduleFilterCombobox: React.FC<
  ScheduleFilterComboboxPropsType
> = ({ filter, setFilter }) => {
  const { t } = useTranslation('dashboard');

  const combobox = useCombobox();

  const handleValueSelect = (value: string) => {
    const eventType = value as EventType;

    setFilter(
      filter.includes(eventType)
        ? filter.filter((item) => item !== eventType)
        : [...filter, eventType]
    );
  };

  return (
    <Combobox
      store={combobox}
      withinPortal
      width="max-content"
      onOptionSubmit={handleValueSelect}
    >
      <Combobox.Target targetType="button">
        <ScheduleHeader.Control
          style={{ marginInlineStart: 'auto' }}
          active={filter.length > 0}
          onClick={() => combobox.toggleDropdown()}
        >
          {t(`${TRANS_PATH}.FILTER`)}
        </ScheduleHeader.Control>
      </Combobox.Target>

      <Combobox.Dropdown>
        <Combobox.Options>
          {EVENT_TYPE_OPTIONS.map((eventType) => (
            <ScheduleFilterComboboxOption
              key={eventType}
              value={eventType}
              isActive={filter.includes(eventType)}
            />
          ))}
        </Combobox.Options>
      </Combobox.Dropdown>
    </Combobox>
  );
};
